const Jimp = window.Jimp;
// Lookup table to convert NES colors to rgb.
// Stolen from: http://www.thealmightyguru.com/Games/Hacking/Wiki/index.php/NES_Palette
const nesRgbLookup = [
    124,124,124,
    0,0,252,
    0,0,188,
    68,40,188,
    148,0,132,
    168,0,32,
    168,16,0,
    136,20,0,
    80,48,0,
    0,120,0,
    0,104,0,
    0,88,0,
    0,64,88,
    0,0,0,
    0,0,0,
    0,0,0,
    188,188,188,
    0,120,248,
    0,88,248,
    104,68,252,
    216,0,204,
    228,0,88,
    248,56,0,
    228,92,16,
    172,124,0,
    0,184,0,
    0,168,0,
    0,168,68,
    0,136,136,
    0,0,0,
    0,0,0,
    0,0,0,
    248,248,248,
    60,188,252,
    104,136,252,
    152,120,248,
    248,120,248,
    248,88,152,
    248,120,88,
    252,160,68,
    248,184,0,
    184,248,24,
    88,216,84,
    88,248,152,
    0,232,216,
    120,120,120,
    0,0,0,
    0,0,0,
    252,252,252,
    164,228,252,
    184,184,248,
    216,184,248,
    248,184,248,
    248,164,192,
    240,208,176,
    252,224,168,
    248,216,120,
    216,248,120,
    184,248,184,
    184,248,216,
    0,252,252,
    248,216,248,
    0,0,0,
    0,0,0,
];

// Use this to translate from a loop index to a single bit. 
const reverseBitmaskLookup = [
    0b10000000,
    0b01000000,
    0b00100000,
    0b00010000,
    0b00001000,
    0b00000100,
    0b00000010,
    0b00000001
];

export default class NesGraphics {


    // Using the lookup table above, convert a color for the NES to its RGBA equivalent, so Jimp can understand.
    static nesToRgb(id) {
        return Jimp.rgbaToInt(nesRgbLookup[id*3], nesRgbLookup[id*3+1], nesRgbLookup[id*3+2], 255);
    }


    static convertToBase64Image(chrContents, palette, specificTileId, options) {
        options = options || {}
        var width = options.width || 128,
            height = options.height || 128,
            singleTile = false;

        if (typeof specificTileId !== 'undefined' && specificTileId != null) {
            width = 8;
            height = 8;
            singleTile = true;
        }
        return new Promise((resolve, reject) => {
            var rgbPalette = [NesGraphics.nesToRgb(palette[0]), NesGraphics.nesToRgb(palette[1]), NesGraphics.nesToRgb(palette[2]), NesGraphics.nesToRgb(palette[3])];
            new Jimp(width, height, function(err, image) {
                if (err) {
                    reject(err);
                    return;
                }

                // NOTE: false actually corrupts the shite out of the image for whatever reason...
                image.rgba(true);

                // See: http://wiki.nesdev.com/w/index.php/PPU_pattern_tables
                // Here's the bulk of what's going on... we loop over the chr file, and translate it to an image. 
                // Apologies, I'm not sure how to document this better...
                if (singleTile) {

                    for (var srowId = 0; srowId < 8; srowId++) {
                        for (var spixelId = 0; spixelId < 8; spixelId++) {
                            var scolorId = (chrContents[(specificTileId*16)+srowId] & reverseBitmaskLookup[spixelId] ? 1 : 0) +  (chrContents[(specificTileId*16)+srowId + 8] & reverseBitmaskLookup[spixelId] ? 2 : 0);

                            image.setPixelColor(rgbPalette[scolorId], spixelId, srowId);

                        }
                    }

                } else {
                    for (var tileRowId = 0; tileRowId < 16; tileRowId++) { // Loop over rows
                        for (var tileId = 0; tileId < 16; tileId++) { // Loop over every tile in row 1
                            for (var rowId = 0; rowId < 8; rowId++) { // Loop over every row in the tile
                                for (var pixelId = 0; pixelId < 8; pixelId++) { // And every bit. (I'm sorry)
                                    var colorId = (chrContents[(tileRowId * 256) + (tileId*16)+rowId] & reverseBitmaskLookup[pixelId] ? 1 : 0) +  (chrContents[(tileRowId * 256) + (tileId*16)+rowId+8] & reverseBitmaskLookup[pixelId] ? 2 : 0);

                                    image.setPixelColor(rgbPalette[colorId], tileId*8 + pixelId, tileRowId*8 + rowId);
                                }
                            }
                        }
                    }
                }

                if (options.rawImage) {
                    resolve(image);
                    return;
                }
                image.getBase64('image/bmp', (err, data) => {
                    if (err) {
                        reject(err);
                        return;
                    }
                    resolve(data)
                });

            });
        });
    }

    // Save as above, but with 16x16 tiles instead of 8x8
    static convertMetaToBase64Image(chrContents, palette, specificTileId, options) {
        options = options || {};
        var width = 16,
            height = 16,
            subTileId = (((specificTileId & 0xf8)) << 2) + ((specificTileId & 0x07) << 1),
            subTileIdRow2 = subTileId + 16;

        return new Promise((resolve, reject) => {
            var rgbPalette = [NesGraphics.nesToRgb(palette[0]), NesGraphics.nesToRgb(palette[1]), NesGraphics.nesToRgb(palette[2]), NesGraphics.nesToRgb(palette[3])];
            new Jimp(width, height, function(err, image) {
                if (err) {
                    reject(err);
                    return;
                }

                image.rgba(true);

                // See: http://wiki.nesdev.com/w/index.php/PPU_pattern_tables
                // Here's the bulk of what's going on... we loop over the chr file, and translate it to an image. 
                // Apologies, I'm not sure how to document this better...
                for (var rowId = 0; rowId < 8; rowId++) {
                    let extra = 0;
                    for (var _pixelId = 0; _pixelId < 16; _pixelId++) {
                        var pixelId = _pixelId;
                        if (_pixelId >= 8) {
                            extra = 16;
                            pixelId -= 8;
                        }
                        var colorId = (chrContents[(subTileId*16)+rowId + extra] & reverseBitmaskLookup[pixelId] ? 1 : 0) +  (chrContents[(subTileId*16)+rowId + 8 + extra] & reverseBitmaskLookup[pixelId] ? 2 : 0);

                        image.setPixelColor(rgbPalette[colorId], _pixelId, rowId);

                        colorId = (chrContents[(subTileIdRow2*16)+rowId + extra] & reverseBitmaskLookup[pixelId] ? 1 : 0) +  (chrContents[(subTileIdRow2*16)+rowId + 8 + extra] & reverseBitmaskLookup[pixelId] ? 2 : 0);

                        image.setPixelColor(rgbPalette[colorId], _pixelId, rowId+8);
                    }
                }

                if (options.rawImage) {
                    resolve(image);
                    return;
                }

                image.getBase64('image/bmp', (err, data) => {
                    if (err) {
                        reject(err);
                        return;
                    }
                    resolve(data)
                });

            });
        });
    }

    static getHexForColor(id) {
        const upId = id*3;
        return `rgb(${nesRgbLookup[upId]},${nesRgbLookup[upId+1]}, ${nesRgbLookup[upId+2]})`;
    }

    static getClosestColorForRgb(obj) {
        let bestMatchKey = null,
            bestMatchVal = 99999;
        for (var i = 0; i < nesRgbLookup.length/3; i++) {
            const key = i*3,
                currentDiff = Math.abs(nesRgbLookup[key] - obj.r) + Math.abs(nesRgbLookup[key+1] - obj.g) + Math.abs(nesRgbLookup[key + 2] - obj.b);
            if (currentDiff < bestMatchVal) {
                bestMatchVal = currentDiff;
                bestMatchKey = i;
            }
        }
        // Special case: avoid the crt-breaking shade of black.
        if (bestMatchKey === 0x0d) {
            bestMatchKey = 0x0f;
        }
        return bestMatchKey;
    }

    static patchReplaceTiles(chrData, tileData, tileId, isMeta) {
        for (let i = 0; i < tileData.length; i++) {
            let thisTileIdx;
            if (isMeta) {
                thisTileIdx = 
                    ((tileId % 8) * 2 * 16) + // 0-7 index, * 2 tiles, * 16 bytes/tile +
                    (Math.floor(tileId / 8) * 2 * 256) + // 0-7 y index, * 2 tiles, * 256 bytes/row 
                    (tileData[i].x * 16) + (tileData[i].y * 256);
            } else {
                thisTileIdx = (tileId*16 + (tileData[i].x * 16) + (tileData[i].y * 16 * 16))
            }

            for (var row = 0; row !== 8; row++) {
                chrData[thisTileIdx + row] = parseInt(tileData[i].compressedData1[row].join(''), 2);
                chrData[thisTileIdx + row + 8] = parseInt(tileData[i].compressedData2[row].join(''), 2);
            }
        }
        return chrData;
    }


    static jimpToChr(image, palette, size) {

        // Build up chr data in a loop
        const rightBits = [0, 0, 1, 1],
            leftBits = [0, 1, 0, 1];
        const chrContents = [];
        // Pre-pad entire array so we can do stuff below.
        for (var i = 0; i < size; i++) {
            chrContents.push(0);
        }
        for (var tileRowId = 0; tileRowId < 16; tileRowId++) { // Loop over rows
            for (var tileId = 0; tileId < 16; tileId++) { // Loop over every tile in row 1
                for (var rowId = 0; rowId < 8; rowId++) { // Loop over every row in the tile
                    for (var pixelId = 0; pixelId < 8; pixelId++) { // And every bit. (I'm sorry)
                        const colorDetails = Jimp.intToRGBA(image.getPixelColor(tileId * 8 + pixelId, tileRowId * 8 + rowId)),
                            colorKey = colorDetails.r + '_' + colorDetails.g + '_' + colorDetails.b + '_' + colorDetails.a,
                            colorId = palette.findIndex(i => i.colorKey === colorKey),
                            chrPos = (tileRowId * 256) + (tileId * 16) + rowId;

                        chrContents[chrPos] += (leftBits[colorId] ? reverseBitmaskLookup[pixelId] : 0);
                        chrContents[chrPos+8] += (rightBits[colorId] ? reverseBitmaskLookup[pixelId] : 0);
                    }
                }
            }
        }

        return chrContents;
    }
}